import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export type UseQuickbooksInfoParams = {
  groupId: string;
};

export type QuickbooksInfoKey = readonly ['integrations', 'quickbooks', string];

export type QuickbooksInfoData = {
  connected: boolean;
  error: string | null;
  url: string | null;
  isNewVersion: boolean;
  isActive: boolean;
};

export const getQuickbooksInfoKey = (
  params: UseQuickbooksInfoParams,
): QuickbooksInfoKey => ['integrations', 'quickbooks', params.groupId] as const;

export const useQuickbooksInfo: QueryFunction<
  QuickbooksInfoData,
  [UseQuickbooksInfoParams],
  QuickbooksInfoKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getQuickbooksInfoKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/integrations/quickbooks/groups/${params.groupId}`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
